import React from 'react';
import Container from './container';

const Poesia = () => {

    return (
        <Container title="Poesia" />
    );
}

export default Poesia;
